// extracted by mini-css-extract-plugin
export default {"root":"styles_root__gkJ1X","checkboxList":"styles_checkboxList__ah7uq"};